/**
 * Static dimension display palette for GO Lab Coverage / Quality
 * surfaces.
 *
 * Colour is a FE-only concern — the API's `DimensionResponse`
 * deliberately omits it (see work-specs §A11 and the verified-context
 * block in work-specs.md). This module owns the palette.
 *
 * Keys are stored lowercase and we accept both hyphen- and
 * underscore-separated aliases (the conduct-intelligence seed has used
 * both forms historically). Unknown keys fall back to slate-500 so the
 * UI never crashes on a new taxonomy.
 */

export const DIMENSION_COLORS: Record<string, string> = {
  dissatisfaction: '#ef4444',         // red — distress / negative outcome
  vulnerability: '#9333ea',           // purple — vulnerability cues
  'customer-strain': '#d97706',       // amber — strain signal
  customer_strain: '#d97706',         // alias
  strain: '#d97706',                  // alias
  'foreseeable-harm': '#dc2626',      // red-700 — high severity
  foreseeable_harm: '#dc2626',        // alias
  harm: '#dc2626',                    // alias
  'outcome-alignment': '#16a34a',     // emerald — positive outcome
  outcome_alignment: '#16a34a',       // alias
  outcome: '#16a34a',                 // alias
  engagement: '#0891b2',              // cyan — neutral / activity signal
};

/** Used when a dimension key isn't in the palette. */
export const DIMENSION_FALLBACK = '#64748b';

/**
 * Look up the display colour for a dimension key. Lowercases the input
 * before lookup, so callers don't have to normalise.
 */
export function getDimensionColor(key: string): string {
  return DIMENSION_COLORS[key.toLowerCase()] ?? DIMENSION_FALLBACK;
}
